import { Formik } from 'formik';
import React, { FC } from 'react';
import { ContainerLarge } from '../../components/base/grid';
import ChangeDestinationForm from '../../components/changeDestinationForm';
import pageWrapper from '../../hoc/pageWrapper';
import IChangeDestination from '../../interfaces/changeDestination/changeDestination';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	values: IChangeDestination;
	errors: any;

	setFieldTouched: any;
	setFieldValue: any;
	isSubmitting: any;
	isValid: any;
	page: IPageViewModel;
}

const initialFormValues: IChangeDestination = {
	// ... your initial form values
	shipmentId: '',
	email: '',
	mobileNumber: '',
	deliveryChoice: null,
	additionalText: '',
	postalCode: null,
};

const ChangeDestination: FC<Props> = () => {
	return (
		<ContainerLarge>
			<Formik
				initialValues={initialFormValues}
				onSubmit={()=>{}}
				// You might also want to pass in a validation schema here
			>
				{formikProps => (
					// Pass the formikProps to your form component
					<ChangeDestinationForm {...formikProps} />
				)}
			</Formik>
		</ContainerLarge>
	);
};

export default pageWrapper(ChangeDestination);
